<template>
  <div class="home">
    <Header 
      @connect="onConnect" 
      @close="isNetworkList = false" 
      @openLanguageModal="onaLanguageModal" 
      :network="networkLabel" 
    />
    <div class="home-container">
      <div class="home-left">
        <div class="pc-title-wrap">
          <div
            class="title"
            :class="{
              claim: locale === 'en',
              blue: locale === 'en' && textFlag1,
            }"
          >
            {{ locale === 'zh' ? $t('home.claimTitle_2') : textEn }}
          </div>
          <div
            class="title"
            :class="{
              claim: locale === 'zh',
              blue: locale === 'zh' && textFlag2,
            }"
          >
            {{ locale === 'zh' ? textZh : $t('home.claimTitle_2') }}
          </div>
          <div class="title">{{ $t('home.claimTitle_3') }}</div>
        </div>
        <div class="mobile-title-wrap">
          <div v-if="locale === 'zh'">
            <div class="mobile-title-zh">
              <div
                class="title"
                :class="{
                  claim: locale === 'en',
                  blue: locale === 'en' && textFlag1,
                }"
              >
                {{ locale === 'zh' ? $t('home.claimTitle_2') : textEn }}
              </div>
              <div
                class="title"
                :class="{
                  claim: locale === 'zh',
                  blue: locale === 'zh' && textFlag2,
                }"
              >
                {{ locale === 'zh' ? textZh : $t('home.claimTitle_2') }}
              </div>
            </div>
            <div class="title">{{ $t('home.claimTitle_3') }}</div>
          </div>
          <div v-if="locale === 'en'">
            <div
              class="title"
              :class="{
                claim: locale === 'en',
                blue: locale === 'en' && textFlag1,
              }"
            >
              {{ locale === 'zh' ? $t('home.claimTitle_2') : textEn }}
            </div>
            <div class="mobile-title-zh mobile-title-en">
              <div
                class="title"
                :class="{
                  claim: locale === 'zh',
                  blue: locale === 'zh' && textFlag2,
                }"
              >
                {{ locale === 'zh' ? textZh : $t('home.claimTitle_2') }}
              </div>
              <div class="title claim-title-3">{{ $t('home.claimTitle_3') }}</div>
            </div>
          </div>
        </div>
        <div class="claim-desc">
          {{ $t('home.airdropDesc') }}
        </div>
        <div class="button" @click="initiateAirdrop">
          {{ $t('home.initiateAirdrop') }}
        </div>
      </div>
      <div
        class="home-right"
        :class="{
          'not-airdrop': airdropStatus === 'not-airdrop',
          'claim-airdrop': airdropStatus === 'claim-airdrop',
        }"
      >
        <img
          v-if="airdropStatus === 'claim-airdrop'"
          class="back-img"
          @click="onBack"
          src="../assets/home/back.png"
          alt=""
        />
        <template
          v-if="
            airdropStatus === 'not-airdrop' || airdropStatus === 'before-check'
          "
        >
          <div class="select-network-wrap" @click.stop="openNetworkList">
            <NetworkData :network="state.currentNetwork" />
            <img
              class="network-arrow"
              v-if="state.currentNetwork.chainId"
              :src="arrowImg"
              alt=""
            />
            <div
              class="network-list-content"
              @click.stop="closeNetworkList"
              v-show="isNetworkList"
            >
              <div class="network-list">
                <div
                  class="network-item"
                  v-for="(item, index) in state.airdropList"
                  :key="index"
                  @click.stop="onSelectNetwork(item, index)"
                >
                  <NetworkData :network="item" />
                  <img
                    v-if="state.currentNetworkIndex === index"
                    class="network-arrow"
                    src="../assets/home/selected.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="desc"
            v-if="locale === 'en'"
            v-html="state.currentNetwork.descriptionsEn"
          ></div>
          <div
            class="desc"
            v-else
            v-html="state.currentNetwork.descriptionsZh"
          ></div>
          <div class="input-wrap">
            <input
              type="text"
              v-model="account"
              @input="inputChange"
              :placeholder="$t('home.placeholder')"
            />
            <div class="check-button" @click="onCheck">
              {{ $t('home.check') }}
            </div>
          </div>
          <div class="not-eligible-airdrop">
            {{ tipsText }}
          </div>
          <div class="TP-airdrop-wrap" v-if="isAirdropEnd">
            <img
              class="TP-airdrop-img"
              src="../assets/home/TP-airdrop.png"
              alt=""
            />
          </div>
          <div class="airdrop-claim-count-down-wrap" v-else>
            <div class="claim-end">{{ $t('home.claimEnd') }}</div>
            <div class="airdrop-claim-count-down">
              <TimeBox
                v-for="(item, index) in state.endTimeList"
                :key="index"
                :timeData="item"
              />
            </div>
          </div>
        </template>
        <div
          class="claim-receive-wrap"
          v-if="airdropStatus === 'claim-airdrop'"
        >
          <div class="title">{{ $t('home.eligibleToClaim') }}</div>
          <div class="claim-receive">{{ $t('home.receive') }}</div>
          <div class="claim-receive-amount">
            <div class="network-token-wrap">
              <img
                class="token-icon"
                v-if="state.claimData.icon"
                :src="state.claimData.icon"
                alt=""
              />
              <img
                class="network-icon"
                v-if="state.currentNetwork.networkIcon"
                :src="state.currentNetwork.networkIcon"
                alt=""
              />
            </div>
            <span v-if="state.claimData.amount">
              {{ state.claimData.amount + ' ' + state.claimData.symbol }}
            </span>
          </div>
          <div class="wrong-address" v-if="isErrorAddress">
            {{ t('home.wrongAddress') }}
          </div>
          <div
            class="connect-claim-button"
            :class="{ disabled: isDisabledButton }"
            @click="onClaim"
          >
            {{ connectClaimText }}
          </div>
          <div class="back-button" @click="onBack">{{ $t('home.back') }}</div>
        </div>
      </div>
    </div>
    <div class="coming-soon" v-show="isComingSoon">{{ $t('comingSoon') }}</div>
    <Modal v-if="languageModal">
      <div class="language-content">
        <div class="language-header">
          <div class="title">{{ $t('settings') }}</div>
        </div>
        <div class="line"></div>
        <div class="language-list">
          <div
            class="language-item"
            v-for="(item, index) in state.languageList"
            :key="index"
            @click="changeLang(item.lang)"
          >
            <span>{{ item.label }}</span>
            <img
              v-if="locale === item.lang"
              src="../assets/home/selected.png"
              alt=""
            />
          </div>
        </div>
        <img
          class="modal-close"
          src="../assets/home/close.png"
          alt=""
          @click="closeLanguageModal"
        />
      </div>
    </Modal>
  </div>
</template>

<script setup>
import {
  computed,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
  watchEffect,
} from 'vue';
// import 'element-plus/dist/index.css';
// import { ElMessage } from 'element-plus';
// import { ElNotification } from 'element-plus'
import Web3 from 'web3';
import { BigNumber } from 'bignumber.js';
import { storeToRefs } from 'pinia';

import { useI18n } from 'vue-i18n';
const { locale, t } = useI18n();

import useLoginTP from '../hooks/useLoginTP';
const { loginTP, switchTPWallet } = useLoginTP();

import { onboard } from '../utils/onboard';
import { CHAIN_INFO_MAP, CHAIN_ID_NETWORK } from '../utils/constants';

import { useCommonStore } from '../stores/common';
const common = useCommonStore();

import { useWalletStore } from '../stores/wallet';
const walletStore = useWalletStore();
const { walletInfo, tpWalletNetwork } = storeToRefs(walletStore);

import useLoginWallet from '../hooks/useLoginWallet';
const { loginTRX } = useLoginWallet();

import emitter from '../utils/bus';

import { setMode, dev, parseWithUnit, getWalletInfo } from '../utils';
import { sendTransactionForTRX } from '../utils/transaction';
import { reqAirdropList, reqAirdropChecking, reqBlockChainList } from '../api';

import Header from '../components/layouts/Header.vue';
import TimeBox from '@/components/tools/TimeBox.vue';
import NetworkData from '@/components/tools/NetworkData.vue';
import Modal from '@/components/tools/Modal.vue';
import { clone, trim } from 'lodash';

let intervalId = null;
let setTimeoutId = null;
let setTimeoutId1 = null;
let setTimeoutId2 = null;

const airdropStatus = ref('before-check');
const endTimestamp = ref(0);
const account = ref('');
const tipsText = ref('');
const isComingSoon = ref(false);
const isNetworkList = ref(false);
const languageModal = ref(false);
const canClaim = ref(false);
const testText = ref('');
const textEn = ref('');
const textZh = ref('');
const textFlag1 = ref(false);
const textFlag2 = ref(false);
const isAddressVaLid = ref(false);
const checkError = ref(false);
const decimals = ref(0);
const tronNode = ref('https://trx.mytokenpocket.vip');
const tronNetwork = ref('TRX');

const state = reactive({
  endTimeList: [
    {
      timeCount: '00',
      timeText: t('home.days'),
    },
    {
      timeCount: '00',
      timeText: t('home.hours'),
    },
    {
      timeCount: '00',
      timeText: t('home.minutes'),
    },
    {
      timeCount: '00',
      timeText: t('home.seconds'),
    },
  ],
  currentNetwork: {},
  currentNetworkIndex: 0,
  airdropList: [],
  web3: null,
  evmProvider: null,
  unsubscribe: null,
  claimData: {
    icon: '',
    symbol: '',
  },
  timeoutIDs: [],
  blockChainList: [],
  languageList: [
    { lang: 'zh', label: '简体中文' },
    { lang: 'en', label: 'English' },
  ],
});


onMounted(() => {
  window.addEventListener('message', onTronLink);
  walletSubscribe();
  getBlockChainList();
  timerChangeText('en');
  timerChangeText('zh');
  emitter.on('connect-wallet', (network) => {
    // console.log('connect-wallet', network);
    connectWallets(network)
  })
  if (common.isTP) {
    loginTP();
  }
  document.body.addEventListener('click', () => {
    isNetworkList.value = false;
  });
});

onUnmounted(() => {
  if (state.unsubscribe) {
    state.unsubscribe()
  }
  if (intervalId) {
    clearInterval(intervalId);
  }
  if (setTimeoutId) {
    clearInterval(setTimeoutId);
  }
  if (setTimeoutId1) {
    clearInterval(setTimeoutId1);
  }
  if (setTimeoutId2) {
    clearInterval(setTimeoutId2);
  }
});

watch(
  () => common.isDark,
  (newValue, oldValue) => {
    let theme = 'light';
    if (newValue) {
      theme = 'dark';
    }
    onboard.state.actions.updateTheme(theme);
  },
  { deep: false }
);

watch(
  () => locale,
  (newValue, oldValue) => {
    state.endTimeList[0].timeText = t('home.days');
    state.endTimeList[1].timeText = t('home.hours');
    state.endTimeList[2].timeText = t('home.minutes');
    state.endTimeList[3].timeText = t('home.seconds');
    tipsText.value = getTipsText();
  },
  { deep: true }
);

watch(
  [() => walletInfo.value, () => state.currentNetwork],
  (newValue, oldValue) => {
    const [newConnected, newCurrentNetwork] = newValue;
    // console.log('newConnected', newConnected);
    // console.log('newCurrentNetwork', newCurrentNetwork);
    // 当在输入查询地址的时候才会把连接钱包的地址填入
    if (airdropStatus.value === 'before-check') {
      account.value = walletInfo.value[networkLabel.value]?.account;
    }
    inputChange();
    // airdropStatus.value = 'before-check';
    if (Object.getOwnPropertyNames(newConnected).length === 0) {
      common.networkError = false;
    } else {
      if (newConnected[networkLabel.value]) {
        common.networkError = false;
      } else {
        common.networkError = true;
      }
    }
  },
  { deep: true }
);


const networkLabel = computed(() => {
  return CHAIN_ID_NETWORK[state.currentNetwork.chainId]
})

watch(
  () => networkLabel.value,
  (n, o) => {
    console.log('networkLabel', n);
    emitter.emit('claim-bg', n)
  },
  {
    immediate: true
  }
)

const darkModeImg = computed(() => {
  return common.isDark ? '-dark' : '';
});

const isZh = computed(() => {
  return locale.value === 'zh';
});

const isDisabledButton = computed(() => {
  if (
    canClaim.value ||
    isErrorAddress.value ||
    (walletInfo.value[networkLabel.value]?.account &&
      !common.networkError &&
      (state.claimData.status === 2 || state.claimData.status === 0))
  ) {
    if (common.networkError) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
});

const isErrorAddress = computed(() => {
  if (account.value && account.value.trim() && walletInfo.value[networkLabel.value]?.account) {
    return (
      walletInfo.value[networkLabel.value]?.account.toLocaleLowerCase() !==
      account.value.toLocaleLowerCase()
    );
  } else {
    return false;
  }
});

const arrowImg = computed(() => {
  return require(`../assets/home/arrow-down${darkModeImg.value}.png`);
});

const connectClaimText = computed(() => {
  const network = CHAIN_ID_NETWORK[state.currentNetwork.chainId]
  if (walletStore.walletInfo[network]?.account) {
    if (common.networkError) {
      return t('home.networkError');
    } else {
      if (state.claimData.status === 1) {
        return t('home.claim');
      } else if (state.claimData.status === 2) {
        return t('home.claimed');
      } else {
        return t('comingSoon');
      }
    }
  } else {
    return t('home.connect');
  }
});

const isAirdropEnd = computed(() => {
  if (endTimestamp.value > new Date().getTime() / 1000) {
    return false;
  } else {
    return true;
  }
});

/** 监听tronLink钱包切换网络 */
const onTronLink = (e) => {
  // DAPP页面加载之前 tabReply 事件判断是主网还是测试网
  if (e.data.message && e.data.message.action == 'tabReply') {
    // console.log('tabReply event', e.data.message);
    if (e.data.message.data.data.code !== 200) {
      if (e.data.message.data?.data?.node?.chainId == '0x2b6653dc') {
        tronNode.value = 'https://trx.mytokenpocket.vip';
        tronNetwork.value = 'TRX'
      } else if (e.data.message.data?.data?.node?.chainId == '0xcd8690dc') {
        tronNode.value = e.data.message.data?.data?.node?.fullNode;
        tronNetwork.value = 'NILE'
      }
    }
  }
  // 切换账号
  if (e.data.message && e.data.message.action == 'accountsChanged') {
    // this.address = e.data.message.data.address;
    // this.loginTronLink();
  }
  // tronLink 切换链监听
  if (e.data.message && e.data.message.action == 'setNode') {
    // console.log('e.data.message', e.data.message);
    if (e.data.message.data?.node?.chainId == '0x2b6653dc') {
      // Grid主网
      tronNode.value = 'https://trx.mytokenpocket.vip';
      tronNetwork.value = 'TRX'
    } else if (e.data.message.data?.node?.chainId == '0xcd8690dc') {
      // Nile测试网
      tronNode.value = e.data.message.data?.node?.fullNode;
      tronNetwork.value = 'NILE'
    }
  }
}

const connectWallets = (network) => {
  switch (network) {
    case 'EVM':
      onConnect()
      break;
    case 'TRX':
      loginTRX()
      // ElNotification.success({
      //   type: 'success',
      //   message: 'This is a message without close button',
      //   showClose: false,
      //   duration: 20000
      // })
      break;
    default:
      break;
  }
}

const inputChange = () => {
  // console.log('account', account.value);
  if (state.currentNetwork.chainId) {
    const network = CHAIN_ID_NETWORK[state.currentNetwork.chainId];
    const addressRegExp = CHAIN_INFO_MAP[network]?.addressRegExp;
    const regExp = new RegExp(addressRegExp);
    if (regExp.test(account.value)) {
      // console.log('地址正确');
      isAddressVaLid.value = true;
    } else {
      // console.log('地址错误');
      isAddressVaLid.value = false;
    }
  }
};

const timerChangeText = (lang) => {
  if (lang === 'en') {
    textFlag1.value = false;
    textEn.value = 'Claim';
    setTimeoutId1 = setInterval(() => {
      if (textFlag1.value) {
        textEn.value = 'Claim';
      } else {
        textEn.value = 'Distribute';
      }
      textFlag1.value = !textFlag1.value;
    }, 3000);
  } else {
    textFlag2.value = false;
    textZh.value = '领取';
    setTimeoutId2 = setInterval(() => {
      if (textFlag2.value) {
        textZh.value = '领取';
      } else {
        textZh.value = '分发';
      }
      textFlag2.value = !textFlag2.value;
    }, 3000);
  }
};

const onaLanguageModal = () => {
  languageModal.value = true;
  document.body.style.overflow = 'hidden';
};

const closeLanguageModal = () => {
  languageModal.value = false;
  document.body.style.overflow = 'auto';
};

const changeLang = (lang) => {
  locale.value = lang;
};

const getTipsText = () => {
  if (airdropStatus.value === 'before-check') {
    if (!account.value) {
      return t('home.addressRequired');
    } else if (!isAddressVaLid.value) {
      return t('home.addressVaLid');
    } else if (endTimestamp.value < new Date().getTime() / 1000) {
      return t('home.endTimeMessage');
    } else if (checkError.value) {
      return t('home.checkError');
    } else {
      return '';
    }
  } else if (airdropStatus.value === 'not-airdrop') {
    return t('home.notEligibleToClaim');
  } else {
    return '';
  }
};

const getBlockChainList = async () => {
  const data = {
    lang: 'zh-Hans',
    version: '0.0.1',
    os: 'web',
  };
  try {
    const res = await reqBlockChainList(data);
    if (res.result === 0 && res.data) {
      state.blockChainList = [];
      res.data.forEach((item) => {
        if (!item.deprecated && item.deprecated !== 1) {
          let obj = {
            ns: item.ns,
            chain_id: JSON.parse(item.metadata).chain_id,
            icon_url: item.icon_url,
            blockchain_id: item.hid,
          };
          if (obj.chain_id) {
            state.blockChainList.push(obj);
          }
        }
      });
      // console.log('blockChainList', state.blockChainList);
      localStorage.setItem(
        'blockChainList',
        JSON.stringify(state.blockChainList)
      );
    } else {
      state.blockChainList =
        JSON.parse(localStorage.getItem('blockChainList')) || [];
    }
    getAirdropList();
  } catch (error) {
    state.blockChainList =
      JSON.parse(localStorage.getItem('blockChainList')) || [];
    getAirdropList();
    console.log(error);
  }
};

const onClaim = () => {
  if (walletInfo.value[networkLabel.value]?.account && !common.networkError) {
    if (state.claimData.status === 1) {
      claimToken();
    }
  } else {
    // onConnect();
    const isEVM = CHAIN_INFO_MAP[networkLabel.value] && CHAIN_INFO_MAP[networkLabel.value].isEVM
    if (isEVM) {
      connectWallets('EVM');
    } else {
      connectWallets(networkLabel.value);
    }
  }
};

const claimToken = async () => {
  if (canClaim.value) {
    return;
  }
  canClaim.value = true;
  const isEVM = CHAIN_INFO_MAP[networkLabel.value].isEVM
  const account = walletInfo.value[networkLabel.value]?.account
  if (networkLabel.value === 'TRX') {
    console.log('claimData', state.claimData);
    const hash = await sendTransactionForTRX({...state.claimData.data, account})
    console.log('hash', hash);
    if (hash) {
      let setIntervalId = setInterval(() => {
        checkTRXTransitionByHash(hash, setIntervalId);
      }, 1000);
      state.timeoutIDs.push(setIntervalId);
    } else {
      canClaim.value = false;
    }
  } else if (isEVM) {
    const myProvider = state.evmProvider || window.ethereum;
    const { contract, data } = state.claimData;
    let param = {
      from: account,
      to: contract,
      data: data,
    };
    myProvider
      .request({
        method: 'eth_sendTransaction',
        params: [param],
      })
      .then((hash) => {
        console.log('hash', hash);
        // checkClaimStatus();
        // 拿到hash之后轮询去查询
        let setIntervalId = setInterval(() => {
          checkEVMTransitionByHash(hash, setIntervalId);
        }, 1000);
        state.timeoutIDs.push(setIntervalId);
      })
      .catch((err) => {
        console.log(err);
        canClaim.value = false;
      });
  }
};

const checkClaimStatus = (setIntervalId) => {
  const data = {
    permitId: state.currentNetwork.permitId,
    account: account.value.trim(),
  };
  reqAirdropChecking(data).then((res) => {
    if (res.code === 0 && res.data) {
      res.data.amount = parseWithUnit(dev(parseFloat(res.data.amount), Math.pow(10, decimals.value)));
      state.claimData = { ...state.claimData, ...res.data };
      if (state.claimData.status === 1) {
        canClaim.value = false;
      } else {
        canClaim.value = true;
      }
    }
  });
};

const checkEVMTransitionByHash1 = (hash) => {
  state.web3.eth.getTransactionReceipt(hash).then((res) => {
    console.log('res', res);
    // if (res.status === 0n) {
    //   console.log('111');
    // }
  }).catch(() => {
    console.log('pending');
  });
};

/** 根据交易 hash 查询TRX交易状态 */
const checkTRXTransitionByHash = (hash, setIntervalId) => {
  window.tronWeb.trx.getTransactionInfo(hash).then(async (res) => {
    // console.log('res', res);
    if (res.receipt && res.receipt.result && res.receipt.result === 'SUCCESS') {
      clearTimeoutIds(setIntervalId);
      state.claimData.status = 2;
      setTimeout(() => {
        checkClaimStatus();
      }, 2000);
    }
  });
}

const checkEVMTransitionByHash = (hash, setIntervalId) => {
  state.web3.eth.getTransactionReceipt(hash).then((res) => {
    // console.log('res', res);
    if (res && res.status === 1n) {
      clearTimeoutIds(setIntervalId)
      state.claimData.status = 2;
    } else if (res.status === 0n) {
      clearTimeoutIds(setIntervalId)
      state.claimData.status = 1;
    }
    setTimeout(() => {
      checkClaimStatus();
    }, 2000);
  }).catch((err) => {
    console.log(err);
  });
};

const clearTimeoutIds = (setIntervalId) => {
  for (let i = 0; i < state.timeoutIDs.length; i++) {
    if (setIntervalId === state.timeoutIDs[i]) {
      clearInterval(setIntervalId);
    }
  }
}

const onConnect = async () => {
  if (common.isTP) {
    if (common.networkError) {
      const blockchain = state.blockChainList.find(
        (item) => item.chain_id === state.currentNetwork.chainId
      );
      if (blockchain) {
        switchTPWallet(String(blockchain.blockchain_id));
      }
    } else {
      loginTP();
    }
  } else {
    const network = CHAIN_ID_NETWORK[state.currentNetwork.chainId];
    // console.log('network', network);
    if (common.networkError) {
      switchEthereumChain(network);
    } else {
      const wallet = await onboard.connectWallet();
    }
  }
};

const switchEthereumChain = async (type) => {
  if (window.ethereum) {
    try {
      const chain_id = CHAIN_INFO_MAP[type].CHAIN_PARAMS[0]?.chainId;
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: chain_id }],
      });
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          await window.ethereum.request({
            method: 'wallet_addEthereumChain',
            params: CHAIN_INFO_MAP[type].CHAIN_PARAMS,
          });
          if (common.isTP) {
            location.reload();
          }
        } catch (addError) {
          console.log('addError', addError);
        }
      }
    }
  }
};

const walletSubscribe = () => {
  const wallets = onboard.state.select();
  const { unsubscribe } = wallets.subscribe((update) => {
    // console.log('update', update)
    if (update.wallets.length) {
      state.web3 = new Web3(update.wallets[0].provider);
      state.evmProvider = update.wallets[0].provider;
      if (state.web3) {
        const wallets = clone(walletInfo.value)
        // 只保留当前连接的EVM的钱包地址
        for (const key in wallets) {
          const isEVM = CHAIN_INFO_MAP[key] && CHAIN_INFO_MAP[key].isEVM
          if (isEVM) {
            delete wallets[key]
          }
        }
        walletStore.walletInfo = wallets;  
        walletStore.evmWalletLabel = trim(update.wallets[0].label.toLowerCase()).split(" ")[0];       
        const chainId = String(parseInt(update.wallets[0]?.chains[0]?.id, 16));
        const account = update.wallets[0]?.accounts[0]?.address;
        const ns = 'ethereum'
        const network = CHAIN_ID_NETWORK[chainId]
        const blockchain = state.blockChainList.find(
          (item) => item.chain_id == chainId
        );
        walletStore.metamaskNetwork = network
        walletStore.walletInfo[network] = { chainId, account, ns, icon: blockchain ? blockchain.icon_url : '' }
      }
    } else {
      // 断开连接
      // walletStore.walletInfo = {}
      const wallets = getWalletInfo(walletInfo.value, walletStore.metamaskNetwork, false);
      walletStore.walletInfo = wallets;
      walletStore.evmWalletLabel = ''
      state.web3 = null;
      state.evmProvider = null;
    }
  });
  state.unsubscribe = unsubscribe;
};

const initiateAirdrop = () => {
  if (!isComingSoon.value) {
    isComingSoon.value = true;
    setTimeoutId = setTimeout(() => {
      isComingSoon.value = false;
    }, 2000);
  }
};

const getAirdropList = async () => {
  try {
    const res = await reqAirdropList();
    if (res.code === 0 && res.data) {
      let list = res.data
      list.forEach((item, index1) => {
        let network = state.blockChainList.find(
          (item1) => item1.chain_id === item.chainId
        );
        if (network) {
          item.networkIcon = network.icon_url;
        }
      });
      const now = new Date().getTime() / 1000;
      console.log('now', now);
      list = list.filter(item => item.endTime >= now)
      state.airdropList = list;
      // state.airdropList = [...list, ...list, ...list];
      let index = 0
      if (common.isTP) {
        index = list.findIndex(fItem => fItem.chainId == walletInfo.value[tpWalletNetwork.value].chainId)
        if (index === -1) {
          index = 0
        }
      }
      // console.log('index', index);
      state.currentNetworkIndex = index
      state.currentNetwork = list[index] || {};
      state.claimData.symbol = list[index]?.symbol;
      state.claimData.icon = list[index]?.icon;
      decimals.value = list[index]?.decimals;
      endTimestamp.value = list[index]?.endTime;
      initCountdown();
    }
  } catch (error) {
    console.log(error);
  }
};

const openNetworkList = () => {
  isNetworkList.value = true;
  if (common.isMobile) {
    document.body.style.overflow = 'hidden';
  }
};

const closeNetworkList = () => {
  isNetworkList.value = false;
  document.body.style.overflow = 'auto';
};

const onSelectNetwork = (network, index) => {
  document.body.style.overflow = 'auto';
  state.currentNetworkIndex = index;
  state.currentNetwork = network;
  state.claimData.symbol = network.symbol;
  state.claimData.icon = network.icon;
  decimals.value = network.decimals;
  endTimestamp.value = network.endTime;
  isNetworkList.value = false;
  airdropStatus.value = 'before-check';
  tipsText.value = '';
  emitter.emit('claim-bg', networkLabel.value)
  initCountdown();
};

const onBack = () => {
  airdropStatus.value = 'before-check';
};

const onCheck = async () => {
  // airdropStatus.value = 'claim-airdrop';
  checkError.value = false;
  tipsText.value = getTipsText();
  if (account.value && !account.value.trim()) {
    return;
  }
  if (endTimestamp.value < new Date().getTime() / 1000) {
    return;
  }
  if (!isAddressVaLid.value) {
    return;
  }
  try {
    const data = {
      permitId: state.currentNetwork.permitId,
      account: account.value.trim(),
    };
    const res = await reqAirdropChecking(data);
    if (res.code === 0 && res.data) {
      if (res.data.amount === '0') {
        airdropStatus.value = 'not-airdrop';
      } else {
        airdropStatus.value = 'claim-airdrop';
      }
      res.data.amount = parseWithUnit(dev(parseFloat(res.data.amount), Math.pow(10, decimals.value)));
      state.claimData = { ...state.claimData, ...res.data };
      tipsText.value = getTipsText();
    } else {
      checkError.value = true;
      tipsText.value = getTipsText();
    }
  } catch (error) {
    console.log(error);
  }
};

const initCountdown = () => {
  clearInterval(intervalId);
  // 获取更新剩余时间的函数
  const updateCountdown = countdown(endTimestamp.value * 1000);
  updateCountdown();
  // 每秒钟更新剩余时间
  intervalId = setInterval(updateCountdown, 1000);
};

const countdown = (endTimestamp) => {
  return function () {
    // 获取当前时间戳
    const now = new Date().getTime();
    // 计算剩余时间（单位：毫秒）
    const timeRemaining = endTimestamp - now;
    if (timeRemaining <= 0) {
      clearInterval(intervalId); // 倒计时结束时清除定时器
      state.endTimeList[0].timeCount = '00';
      state.endTimeList[1].timeCount = '00';
      state.endTimeList[2].timeCount = '00';
      state.endTimeList[3].timeCount = '00';
      return;
    }
    // 计算剩余时间的天数、小时数、分钟数和秒数
    let days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    let minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
    if (days < 10) {
      days = '0' + days;
    }
    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    // 输出剩余时间
    // console.log('剩余天数：' + days);
    // console.log('剩余小时数：' + hours);
    // console.log('剩余分钟数：' + minutes);
    // console.log('剩余秒数：' + seconds);
    state.endTimeList[0].timeCount = days;
    state.endTimeList[1].timeCount = hours;
    state.endTimeList[2].timeCount = minutes;
    state.endTimeList[3].timeCount = seconds;
  };
};

const scrollIntoView = () => {
  const node = document.querySelector('.big-card-list');
  if (node) {
    node.scrollIntoView({
      behavior: 'smooth', // 平滑过渡
      block: 'center', // 居中
    });
  }
};

const changLang = () => {
  if (locale.value === 'zh') {
    locale.value = 'en';
  } else {
    locale.value = 'zh';
  }
};
</script>

<style lang="scss" scoped>
@import '../style/home.scss';
</style>
